/*
  Что должник возразил и можно ли к нему обращаться — §3.5, §3.8.

  Заведено 16.09.2026. До этого дня возражение должника меняло работу системы -
  ставило обращения на паузу, выводило счёт из автоматики, - но человеку,
  который будет по этому счёту звонить, не показывалось ничем. Хуже всего это
  было со словами самого должника: он писал их на своей странице под обещанием
  «это увидит сотрудник организации», а не видел их никто.

  🔴 Сокращено 25.09.2026 вместе с переработкой шапки карточки. Блок перестал
  перечислять последствия - «обращения приостановлены до 16.10.2026», «счёт
  ждёт человека»: у них есть срок, и они стоят опорными датами во второй
  колонке шапки, где их собирает сервер. Двух мест про один и тот же факт
  остаться не должно - они расходятся при первой правке. («Счёт ждёт человека»
  с 06.10.2026 - не опорная дата, а своя плашка с кнопкой возврата.)

  За блоком осталось то, чего нет больше нигде: СЛОВА должника, вид возражения
  и запрет обращаться. Запрет - не срок: он не кончается сам, и потому назван
  здесь, цветом и над карточкой, а не строкой в списке дат.

  Блока нет вовсе, пока должник ничего не заявлял: пустой блок означал бы
  контакт, в котором он промолчал, а это другое событие.
*/

import { PAUSE_REASON_TITLES, dateTime } from '../api/format.js'
import { Tag } from './Common.jsx'

export default function ContactState({ state }) {
  /*
    Показывать нечего, пока нет ни слов, ни возражения, ни запрета. Счёт,
    который просто ждёт человека, сюда не попадает: это состояние работы, и с
    06.10.2026 у него своя плашка с кнопкой возврата (`NeedsHumanNotice`).
  */
  if (!state) return null
  if (!state.note && !state.objection && !state.do_not_contact) return null

  return (
    <section className="section card">
      <h2 className="section__title section__title--spaced">
        {heading(state)}
        {state.objection ? (
          <Tag kind={state.do_not_contact ? 'burn' : 'warn'}>
            {PAUSE_REASON_TITLES[state.objection]}
          </Tag>
        ) : null}
      </h2>

      {state.note ? <blockquote className="said">{state.note}</blockquote> : null}

      <div className="muted">{where(state)}</div>
      {/*
        Единственное последствие, у которого нет срока, и потому единственное,
        названное здесь: следующее обращение после такой просьбы - это жалоба.
      */}
      {state.do_not_contact ? (
        <div className="muted">
          Обращаться нельзя: должник отказался от обращений. Отказ сам не кончается.
        </div>
      ) : null}
    </section>
  )
}

/* Чем это было. Отказ назван первым: он запрещает работу по счёту целиком. */
function heading(state) {
  if (state.do_not_contact) return 'Отказ от обращений'
  return state.objection ? 'Возражение должника' : 'Слова должника'
}

/*
  Откуда пришло и когда. Источник важен не для порядка: если это разговор, у
  оператора есть запись, и слова можно послушать; если кабинет - есть только
  текст, и переспрашивать придётся заново.
*/
function where(state) {
  const when = dateTime(state.updated_at)
  return state.source ? `${state.source}, ${when}` : when
}
